export default __webpack_public_path__ + "static/media/spiderman-text.46aef9f7.png";